import Vue from "vue";
import {ActionTree, MutationTree} from "vuex";
import {RootState} from "@/store/types";
import {Question, Survey} from "@/store/modules/lib";
import axios from "axios";
import {SERVER_HOST_QR} from "@/config";
import VueI18n from '../../helpers/i18n';
import store from '@/store'


export interface State {
  surveys: Survey[];
  loadStatus: string;
  SurveysFromServer: any[];
}

const defaultState: State = {
  surveys: [],
  loadStatus: "",
  SurveysFromServer: []
};

const getters = {
  SurveysFromServer: (state: State) => {
    VueI18n.locale = store.state.locale.locale
    return [{id: 'all', text: VueI18n.t('newShardList.filter.hotLevel.all')}].concat(state.SurveysFromServer)
  },
  surveys: (state: State) => state.surveys,
  surveyById: (state: State) => (id: string) =>
    state.surveys.find((survey: Survey) => survey._id == id),
};

const mutations: MutationTree<State> = {
  setSurveysFromServer(state:State,payload:any[]){
    // VueI18n.locale = store.state.locale.locale
    const s = payload.map((el:any)=>{return {id:el.survey.id,text:el.survey.title}})
    // s.unshift( {id: 'all', text: VueI18n.t('newShardList.filter.hotLevel.all')})
    state.SurveysFromServer = s
  },
  loading(state: State) {
    state.loadStatus = "loading";
    state.surveys = [];
  },
  setup(state: State, surveys: Survey[]) {
    state.loadStatus = "shards success";
    state.surveys = surveys;
  },
  error(state: State) {
    state.loadStatus = "error";
    state.surveys = [];
  },
  deleteQuestion(state: State, questions: Question[]) {
    console.log(questions)
    state.surveys[0].questions = [...questions];
  },
};

const actions: ActionTree<State, RootState> = {
  async loadSurveyFromServer({commit}) {
    try {
      const {data} = await axios.get(SERVER_HOST_QR + 'surveys')
      if (data.error) {
        throw (data.error)
      }
      commit('setSurveysFromServer',data.data)
    } catch (e) {
      this.commit('alerts/setAlert', {
        show: true,
        color: 'red',
        messages: [e]
      })
      console.log(e.message)
    }
  },

  deleteQuestion({commit, state}, questionId) {
    const questions = this.state.survey.surveys[0].questions;
    const indexOfQstToDelete = questions
      .map((question: Question) => question.id)
      .indexOf(questionId);
    questions.splice(indexOfQstToDelete, 1);
    commit("deleteQuestion", questions);
  },
  load({commit}, {exhibitor}) {
    return new Promise((resolve, reject) => {
      commit("loading");
      Vue.axios({
        url: "/query",
        method: "POST",
        data: `
          {
            "query": "query{Surveys(_exhibitor:\\"${exhibitor}\\"){ count values { _id hasSignature title questions {  answerTitle help id important  order specify  text  type  answers { id sense type order value includeQuestions } }  } }}",
            "variables": {}
          }
        `,
      })
        .then((resp: any) => {
          if (resp.data.status == "ok") {
            commit("setup", resp.data.data.Surveys.values);
            resolve({surveys: resp.data.data.Surveys.values});
            // return resp.data.data.Surveys.values.surveys;
          } else {
            reject(resp);
          }
        })
        .catch((err: any) => {
          commit("error");
          reject(err);
        });
    });
  },
};

export default {
  namespaced: true,
  state: defaultState,
  getters,
  mutations,
  actions,
};
